import { Show, Match, Switch } from 'solid-js';
import {DateTime} from 'luxon';
import { CleanTime, formatDateTime, daysOfWeekly, weekday, week } from 'Shared/common/Macros';


export function DateTitle(P)
{
	return (
		<Switch>
			<Match when={P.frequency == 'once'}>
				<Show when={P.startSingle}>
					{formatDateTime(P.startSingle,'EEE, dd LLL')}
					<StartTime time={P.startSingle} />
				</Show>
			</Match>
			<Match when={P.frequency == 'daily'}>
				Daily
				<StartTime time={P.startTime} allDay={P.allDay} />
			</Match>
			<Match when={P.frequency == 'weekly'}>
				{daysOfWeekly(P.weekdays)}
				{' '}
				{P.days}
				<StartTime time={P.startTime} allDay={P.allDay} />
			</Match>
			<Match when={P.frequency == 'monthly'}>
				{week(P.week)} 
				{' '}
				{weekday(P.weekday)} of month
				<StartTime time={P.startTime} allDay={P.allDay} separator=', ' />
			</Match>
		</Switch>
	);
}


export function DateTitleWithEndTimes(P)
{
	return (
		<Switch>
			<Match when={P.frequency == 'once'}>
				<Show when={P.startSingle}>
					{ DateTime.fromISO(P.startSingle).toFormat('EEE, dd LLL') }
					<StartTime time={P.startSingle} />
				</Show>
				<Show when={P.endSingle} fallback=' until close'>
					{' '}
					until <CleanTime time={P.endSingle}/>
				</Show>
			</Match>
			<Match when={P.frequency == 'daily'}>
				Every Day
				<StartTime time={P.startTime} allDay={P.allDay} />
			</Match>
			<Match when={P.frequency == 'weekly'}>
				{daysOfWeekly(P.weekdays)}
				{' '}
				{P.days}
				<StartTime time={P.startTime} allDay={P.allDay} />

				<Show when={P.endTime} fallback=' until close'>
					{' '}
					until <CleanTime time={P.endTime}/>
				</Show>
			</Match>
			<Match when={P.frequency == 'monthly'}>
				{P.week}
				{' '}
				{weekday(P.weekday)} of month

				<StartTime time={P.startTime} allDay={P.allDay} separator=', ' />

				<Show when={P.endSingle} fallback=' until close'>
					{' '}
					until <CleanTime time={P.endSingle}/>
				</Show>
			</Match>
		</Switch>
	);
}

function StartTime(P)
{
	return (
		<Show when={P.time && !P.allDay}>
			{P.separator ??  ' '}
			<CleanTime time={P.time} />
		</Show>
	);
}
